module.exports = "https://r.zoocdn.com/_next/static/images/favicon-32x32-4d476fcc82d3003a65b67367786c7e37.png";